export const teamMembers = [
  {
    name: "Gizem Deniz",
    imgFile: "https://media.kommunity.com/avatar/_avatar_5eb06c6384ffd.",
    description: "team.headers.gizemdescription",
    github: "https://github.com/gizemcdeniz",
    linkedin: "https://www.linkedin.com/in/gizem-deniz/",
  },
  {
    name: "Bertaç Severcan",
    imgFile:
      "https://avatars0.githubusercontent.com/u/62285626?s=400&u=6b1b3246b176803d980b38009fbb9de5e6c9340e&v=4",
    description: "team.headers.bertacdescription",
    className: "rcorners",
    github: "https://github.com/bertacsevercan",
    linkedin: "https://www.linkedin.com/in/bertac-severcan/",
  },
  {
    name: "Ihab Sensei",
    imgFile:
      "https://avatars1.githubusercontent.com/u/67783666?s=400&u=a7614ba568545504cfb816b5dcc24387ee05af1f&v=4",
    description: "team.headers.ihabdescription",
    className: "rcorners",
    github: "https://github.com/ihab-sensei",
    linkedin: "https://www.linkedin.com/in/ihab-almashhadani-a8b00a1b7/",
  },
  {
    name: "Cihan Uygur",
    imgFile:
      "https://avatars1.githubusercontent.com/u/54838188?s=400&u=cacf1a0f5382a04f2c7a40c46fdcab2ffd088e51&v=4",
    description: "team.headers.cihandesription",
    github: "https://github.com/cuygur",
    linkedin: "https://www.linkedin.com/in/cihanuygur/",
  },
];
